  // Format ID to show last 8 characters in uppercase
  export const formatId = (id) => {
    return id ? id.slice(-8).toUpperCase() : '-';
  };